import { resolveLocale } from '@/lib/utils';

/**
 * «14:05» of an ISO instant in the app's locale (§8.2) — `resolveLocale()`,
 * not the browser default: the UI language decides how a time reads (the AU-11
 * rule of `routes/records/utils.ts`; owner's review, 17.09). A dash when the
 * server named no moment.
 */
export function formatResetTime(resetAt: string | null): string {
  return resetAt
    ? new Date(resetAt).toLocaleTimeString(resolveLocale(), {
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';
}
